var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [(_vm.responseCard.title.trim()) ? _c('v-card-title', {
    staticClass: "red lighten-5",
    attrs: {
      "primary-title": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.responseCard.title))])]) : _vm._e(), _vm._v(" "), (_vm.responseCard.subTitle) ? _c('v-card-text', [_c('span', [_vm._v(_vm._s(_vm.responseCard.subTitle))])]) : _vm._e(), _vm._v(" "), (_vm.responseCard.imageUrl) ? _c('v-card-media', {
    attrs: {
      "src": _vm.responseCard.imageUrl,
      "contain": "",
      "height": "33vh"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.responseCard.buttons), function(button, index) {
    return _c('v-card-actions', {
      key: index,
      staticClass: "button-row",
      attrs: {
        "actions": ""
      }
    }, [(button.text && button.value) ? _c('v-btn', {
      attrs: {
        "disabled": _vm.hasButtonBeenClicked,
        "default": ""
      },
      nativeOn: {
        "~click": function($event) {
          _vm.onButtonClick(button.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(button.text) + "\n    ")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.responseCard.attachmentLinkUrl) ? _c('v-card-actions', [_c('v-btn', {
    staticClass: "red lighten-5",
    attrs: {
      "flat": "",
      "tag": "a",
      "href": _vm.responseCard.attachmentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n      Open Link\n    ")])], 1) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-799b9a4e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResponseCard.vue
// module id = 171
// module chunks = 1